import './scss/index.scss'
import * as bootstrap from 'bootstrap'

window.bootstrap = bootstrap

function domReady(fn) {
	// If we're early to the party
	document.addEventListener('DOMContentLoaded', fn)
	// If late; I mean on time.
	if (document.readyState === 'interactive' || document.readyState === 'complete') {
		fn()
	}
}

console.log('FRONTEND aaa')

domReady(() => {

	window.onscroll = function() {
		document.querySelectorAll('.wp-bootblock-is-parallax').forEach((el) => {
			const top = window.pageYOffset - (window.pageYOffset + el.getBoundingClientRect().top) + (160)
			el.style.backgroundPositionY = 'calc(50% + ' + (top / 3) + 'px)'
		})
	}

	// observerElements.forEach(el => {
	//
	// 	console.log('desc: ', el)
	//
	// 	el.observer = new IntersectionObserver(entry => {
	// 		if (entry[0].intersectionRatio > 0) {
	// 			console.log('IS OBSERVERING')
	// 			progress()
	// 		} else {
	// 			console.log('NOT OBSERVERING')
	// 		}
	// 	}, {
	// 		root: null,
	// 		rootMargin: '0px 0px',
	// 		threshold: 0
	// 	})
	//
	// 	const progress = () => {
	// 		const scrollPosition = (window.scrollY + window.innerHeight)
	// 		const elPosition = (scrollPosition - el.offsetTop)
	// 		const durationDistance = (window.innerHeight + el.offsetHeight)
	// 		const currentProgress = (elPosition / durationDistance)
	// 		console.log('scrollPosition: ', scrollPosition)
	// 		console.log('elPosition: ', elPosition)
	// 		console.log('durationDistance: ', durationDistance)
	// 		console.log('currentProgress: ', currentProgress)
	// 	}
	//
	// 	el.observer.observe(el)
	// })


})
